/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trial_day_number: NonNullable<unknown>, plan_price: NonNullable<unknown> }} Onboarding_Paywall_Footer_MonthlyInputs */

const en_onboarding_paywall_footer_monthly = /** @type {(inputs: Onboarding_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enjoy ${i?.trial_day_number} days for free, then ${i?.plan_price} Monthly. Cancel anytime.`)
};

const ar_onboarding_paywall_footer_monthly = /** @type {(inputs: Onboarding_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`استمتع بـ ${i?.trial_day_number} أيام مجانًا، ثم ${i?.plan_price} شهريًا. يمكنك الإلغاء في أي وقت`)
};

const de_onboarding_paywall_footer_monthly = /** @type {(inputs: Onboarding_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Genieße ${i?.trial_day_number} Tage kostenlos, danach ${i?.plan_price} pro Monat. Jederzeit kündbar.`)
};

const es_onboarding_paywall_footer_monthly = /** @type {(inputs: Onboarding_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Disfruta de ${i?.trial_day_number} días gratis, luego ${i?.plan_price} al mes. Cancela en cualquier momento.`)
};

const fr_onboarding_paywall_footer_monthly = /** @type {(inputs: Onboarding_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Profitez de ${i?.trial_day_number} jours gratuits, puis ${i?.plan_price} par mois. Résiliez quand vous voulez.`)
};

const it_onboarding_paywall_footer_monthly = /** @type {(inputs: Onboarding_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Goditi ${i?.trial_day_number} giorni gratis, poi ${i?.plan_price} al mese. Annulla in qualsiasi momento.`)
};

const ja_onboarding_paywall_footer_monthly = /** @type {(inputs: Onboarding_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trial_day_number}日間無料でお楽しみいただけます。その後は月額 ${i?.plan_price} です。いつでもキャンセル可能です。`)
};

const ko_onboarding_paywall_footer_monthly = /** @type {(inputs: Onboarding_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trial_day_number}일간 무료로 이용해 보세요. 이후에는 월 ${i?.plan_price}입니다. 언제든지 취소할 수 있습니다.`)
};

const pt_br_onboarding_paywall_footer_monthly = /** @type {(inputs: Onboarding_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aproveite ${i?.trial_day_number} dias grátis, depois ${i?.plan_price} por mês. Cancele quando quiser.`)
};

const ru_onboarding_paywall_footer_monthly = /** @type {(inputs: Onboarding_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Попробуйте ${i?.trial_day_number} дн. бесплатно, затем ${i?.plan_price} в месяц. Отмена в любое время.`)
};

const th_onboarding_paywall_footer_monthly = /** @type {(inputs: Onboarding_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เพลิดเพลินกับการใช้งานฟรี ${i?.trial_day_number} วัน หลังจากนั้น ${i?.plan_price} ต่อเดือน ยกเลิกได้ทุกเมื่อ`)
};

const tr_onboarding_paywall_footer_monthly = /** @type {(inputs: Onboarding_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.trial_day_number} gün ücretsiz kullanın, ardından aylık ${i?.plan_price}. İstediğin zaman iptal edebilirsin.`)
};

const zh_cn_onboarding_paywall_footer_monthly = /** @type {(inputs: Onboarding_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免费试用 ${i?.trial_day_number} 天，之后每月 ${i?.plan_price}。可随时取消。`)
};

const zh_tw_onboarding_paywall_footer_monthly = /** @type {(inputs: Onboarding_Paywall_Footer_MonthlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免費試用 ${i?.trial_day_number} 天，之後每月 ${i?.plan_price}。可隨時取消。`)
};

/**
* | output |
* | --- |
* | "Enjoy {trial_day_number} days for free, then {plan_price} Monthly. Cancel anytime." |
*
* @param {Onboarding_Paywall_Footer_MonthlyInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_footer_monthly = /** @type {((inputs: Onboarding_Paywall_Footer_MonthlyInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Footer_MonthlyInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_footer_monthly(inputs)
	if (locale === "ar") return ar_onboarding_paywall_footer_monthly(inputs)
	if (locale === "de") return de_onboarding_paywall_footer_monthly(inputs)
	if (locale === "es") return es_onboarding_paywall_footer_monthly(inputs)
	if (locale === "fr") return fr_onboarding_paywall_footer_monthly(inputs)
	if (locale === "it") return it_onboarding_paywall_footer_monthly(inputs)
	if (locale === "ja") return ja_onboarding_paywall_footer_monthly(inputs)
	if (locale === "ko") return ko_onboarding_paywall_footer_monthly(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_footer_monthly(inputs)
	if (locale === "ru") return ru_onboarding_paywall_footer_monthly(inputs)
	if (locale === "th") return th_onboarding_paywall_footer_monthly(inputs)
	if (locale === "tr") return tr_onboarding_paywall_footer_monthly(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_footer_monthly(inputs)
	return zh_tw_onboarding_paywall_footer_monthly(inputs)
});